{/* Technical draft — must be reviewed by a legal professional before going live. */}

export function AGBPage() {
  return (
    <div className="max-w-3xl mx-auto py-12">
      <h1 className="text-2xl font-serif mb-6">Allgemeine Geschäftsbedingungen / Auktionsbedingungen</h1>

      <div className="prose prose-sm max-w-none text-text-secondary space-y-6">
        <p><strong>Geltungsbereich:</strong> Diese AGB gelten ausschließlich fur Unternehmen im Sinne des § 14 BGB. Verbraucher sind vom Zugang ausgeschlossen.</p>

        <h2 className="font-serif text-xl">1. Plattformbeschreibung</h2>
        <p>Geschlossener Bieterkreis, Zugang nur mit persönlichem Einladungscode.</p>

        <h2 className="font-serif text-xl">2. Registrierung und Zulassung</h2>
        <p>Registrierung erfordert validen Einladungscode, komplette Unternehmensdaten und Bestatigung der B2B-Natur. Nach E-Mail-Verifikation durchlauft das Konto die KYC-Pruifung und wird manuell durch den Administrator freigeschaltet.</p>

        <h2 className="font-serif text-xl">3. Auktionsdurchführung</h2>
        <p>Aufsteigende englische Auktion mit anonymisierten Bietnummern. Mindestgebot und Mindestschrittweite sind pro Auktion festgelegt. Soft-Close-Regel: Gebot in den letzten 5 Minuten verlanguert die Frist um 5 Minuten.</p>

        <h2 className="font-serif text-xl">4. Bindungswirkung</h2>
        <p>Jedes Gebot ist rechtsverbindlich und unwiderruflich (in Anlehnung an § 156 BGB). Ein Rücktritt ist im UI nicht vorgesehen.</p>

        <h2 className="font-serif text-xl">5. Zuschlag</h2>
        <p>Vorläufiger Zuschlag an den Höchstbietenden. Endgultiger Zuschlag erst nach bestandener Compliance-Pruifung. Kaskade an Reservebieter bei Nichtbestehen.</p>

        <h2 className="font-serif text-xl">6. Compliance-Prüfung</h2>
        <p>Verweis auf die separate <a href="/compliance" className="underline">Compliance-Richtlinie</a>.</p>

        <h2 className="font-serif text-xl">7. Kaufpreis und Zahlung</h2>
        <p>Zahlung innerhalb der gesetzten Frist. Bei Verzug: gesetzliche Verzugsfolgen. Eigentumsvorbehalt bis Zahlungseingang.</p>

        <h2 className="font-serif text-xl">8. Übertragung</h2>
        <p>Patent Assignment wird bereitgestellt. Eintragung beim Patentamt obliegt dem Käufer.</p>

        <h2 className="font-serif text-xl">9. Gewährleistung</h2>
        <p>Verkaufser steht für rechtswirksamen Bestand zum Zuschlagszeitpunkt ein. Keine Gewähr für wirtschaftliche Verwertbarkeit.</p>

        <h2 className="font-serif text-xl">10. Haftung</h2>
        <p>Beschränkt auf Vorsatz und grobe Fahrlässigkeit.</p>

        <h2 className="font-serif text-xl">11. Sperre und Ausschluss</h2>
        <p>Bei Verstoß gegen AGB kann der Zugang gesperrt und der Bieter ausgeschlossen werden.</p>

        <h2 className="font-serif text-xl">12. Vertraulichkeit</h2>
        <p>Bieter durfen Existenz und Inhalt der Auktionen nicht öffentlich machen.</p>

        <h2 className="font-serif text-xl">13. Datenschutz</h2>
        <p>Verweis auf <a href="/datenschutz" className="underline">Datenschutzerklärung</a>.</p>

        <h2 className="font-serif text-xl">14. Anwendbares Recht</h2>
        <p>Deutsches Recht, UN-Kaufrecht ausgeschlossen. Gerichtsstand: Berlin.</p>

        <h2 className="font-serif text-xl">15. Salvatorische Klausel</h2>
        <p>Unwirksamkeit einzelner Bestimmungen beruht die Wirksamkeit der übrigen nicht.</p>
      </div>
    </div>
  );
}
